// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.35 2H5.4C6.15 2 6.75 2.6 6.75 3.35V5.4C6.75 6.15 6.15 6.75 5.4 6.75H3.35C2.6 6.75 2 6.15 2 5.4V3.35C2 2.6 2.6 2 3.35 2Z',
  'M10.6 2H12.65C13.4 2 14 2.6 14 3.35V5.4C14 6.15 13.4 6.75 12.65 6.75H10.6C9.85 6.75 9.25 6.15 9.25 5.4V3.35C9.25 2.6 9.85 2 10.6 2Z',
  'M3.35 9.25H5.4C6.15 9.25 6.75 9.85 6.75 10.6V12.65C6.75 13.4 6.15 14 5.4 14H3.35C2.6 14 2 13.4 2 12.65V10.6C2 9.85 2.6 9.25 3.35 9.25Z',
  'M10.6 9.25H12.65C13.4 9.25 14 9.85 14 10.6V12.65C14 13.4 13.4 14 12.65 14H10.6C9.85 14 9.25 13.4 9.25 12.65V10.6C9.25 9.85 9.85 9.25 10.6 9.25Z',
];
